import React from 'react';
import xhr from './../../utils/xhr';
import utils from './../../utils/utilities';
import reduxStore from './../../reduxStore';
import { FormattedMessage } from 'react-intl';
import Header from './../../reusable/Header/Header.index.jsx';
import Footer from './../../reusable/Footer/Footer.index.jsx';
import LoadingSpinner from './../../reusable/LoadingSpinner/LoadingSpinner.index.jsx';


export default class UnsubscribePage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            unsubscribed: false
        }
    }

    componentDidMount() {
        let params = [];
        try {
            params = utils.getAllUrlParams();
            xhr.post({
                url: '/login/unsubscribe',
                data: params
            }).then((response) => {
                this.setState({ unsubscribed: true });
            }).catch(e => {
                this.errorPage(e);
            })
        } catch(e) {
            this.errorPage(e);
        }
    }

    errorPage(e) {
        xhr.handleAllErrors(e);
    }

    render() {
        return (
            <div className='app-wrapper'>
                <Header disableMenu />
                <div className='app-content-wrapper'>
                    { this.state.unsubscribed ?
                        <h2 className={"single-message"}><FormattedMessage id={"Alerts_Manage_UIText_SubscriptionMainMessage"}/></h2>
                        : <LoadingSpinner fixedSpinner={true} isVisible={true}/>
                    }
                </div>
                <Footer version={reduxStore.getState().header.version} />
            </div>
        );
    };

}



// WEBPACK FOOTER //
// ./src/scripts/pages/UnsubscribePage/UnsubscribePage.jsx